import React, { useEffect, useState } from 'react';
import { useLang } from '../LanguageContext';
import LazyImage from '../components/LazyImage';
import { normalizeMediaList } from '../utils/media';

export default function NewsPage() {
  const { t, lang } = useLang();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/news')
      .then((res) => res.json())
      .then((data) => {
        setNews(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        console.error('Failed to fetch news', err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const locale = lang === 'he' ? 'he-IL' : lang === 'es' ? 'es-ES' : lang;
    return date.toLocaleString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  if (loading) {
    return (
      <section className="page-section">
        <div className="container">
          <p>{t('loading')}</p>
        </div>
      </section>
    );
  }

  return (
    <section className="page-section">
      <div className="container">
        <h2 className="text-uppercase mb-4">{t('news')}</h2>
      {news.length === 0 ? (
        <p>{t('noNews')}</p>
      ) : (
        news.map((item) => {
          const media = normalizeMediaList(item.images || []);
          const mainMedia = media[0];
          return (
          <div key={item.id || item._id} className="card mb-3 shadow-sm">
            <div className="card-body text-center">
              <h2 className="card-title h5 fw-bold mb-3">{item.title}</h2>
              {mainMedia && (
                mainMedia.type === 'video' ? (
                  <video
                    src={mainMedia.url}
                    poster={mainMedia.thumbnailUrl || mainMedia.url}
                    controls
                    className="img-fluid rounded mb-3"
                  />
                ) : (
                  <LazyImage
                    src={mainMedia.url}
                    alt=""
                    className="img-fluid rounded mb-3"
                  />
                )
              )}
              <p className="card-text text-start">{item.body}</p>
              <div className="text-muted small">{formatDate(item.createdAt)}</div>
            </div>
          </div>
        );
      })
      )}
      </div>
    </section>
  );
}
